export default {
    getUsuarioLogado: state => state.comum.usuarioLogado
}